import React, { Component } from "react";
import { connect } from "react-redux";
import { Async } from "react-select";
import * as selectors from "../../reducers";
import "react-select/dist/react-select.css";
import "./search.scss";
import {
  setActiveFeature,
  setActiveProject,
  setSearchedLocation,
  setSearchBarVisible,
  setSidebarIsOpen,
} from "../../actions/ui";
import { projectShape } from "../../modules/project";
import pointInPolygon from "@turf/boolean-point-in-polygon";
import turfPoint from "turf-point";
import PropTypes from "prop-types";
import { getGeoJSON } from "../../actions/data";
import styles from "./search.module.scss";
import enhanceWithClickOutside from "react-click-outside";

const ESC_KEY = 27;

const getMatchedProjects = (text, projects) => {
  return new Promise((res, rej) => {
    const matchedProjects = projects
      .filter((d) => {
        return (
          d["project"].toLowerCase().includes(text.toLowerCase()) ||
          d["organisation"].toLowerCase().includes(text.toLowerCase()) ||
          d["description"].toLowerCase().includes(text.toLowerCase()) ||
          d["location"].toLowerCase().includes(text.toLowerCase())
        );
      })
      .map((d) => {
        return {
          value: d,
          label: `${d["project"]}  (${d["organisation"]})  (${d["description"]})  (${d["location"]})`,
        };
      });
    res(matchedProjects);
  });
};
const getMatchedElectorates = (text, features, nameSelector) => {
  return new Promise((res, rej) => {
    const matchedProjects = features
      .filter((d) => nameSelector(d).toLowerCase().includes(text.toLowerCase()))
      .map((d) => ({
        value: d,
        label: nameSelector(d),
      }));
    res(matchedProjects);
  });
};

class GeoSearchInput extends Component {
  constructor() {
    super();
    this.getOptions = this.getOptions.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }
  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyDown);
  }
  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
  }
  handleClickOutside() {
    this.props.setSearchBarVisible(false);
  }
  handleKeyDown(event) {
    if (event.keyCode === ESC_KEY) {
      this.props.setSearchBarVisible(false);
    }
  }

  handleOnChange(d) {
    if (!d) {
      this.props.setActiveFeature(undefined);
      this.props.setActiveProject(null);
      return;
    }
    if (d.value.geometry) {
      this.props.setActiveFeature(d.value);
      this.props.setSidebarIsOpen(true);
      this.props.setSearchBarVisible(false);

      return;
    }
    if (d.value.project) {
      this.props.setActiveProject(d.value.project);
    }

    const optionPos = [d.value.longitude, d.value.latitude];
    const activeFeature = this.props.geojson.features.find((feature) => {
      return pointInPolygon(turfPoint(optionPos), feature);
    });

    this.props.setActiveFeature(activeFeature);

    this.props.setSidebarIsOpen(true);
    this.props.setSearchBarVisible(false);
  }

  getOptions(text) {
    if (!text || text.length < 1) {
      return Promise.resolve({ options: [] });
    }
    const { geometryConfig, geojson } = this.props;

    const projectsP = getMatchedProjects(text, this.props.projects);
    const electoratesP = getMatchedElectorates(
      text,
      geojson.features,
      geometryConfig.nameSelector
    );
    return Promise.all([projectsP, electoratesP])
      .then(([projects, electorates]) => {
        return {
          options: projects.concat(electorates),
        };
      })
      .catch((err) => console.log(err));
  }
  optionsRenderer(option) {
    if (!option) return null;

    const label = option.value.geometry ? "Region" : "Project";
    return (
      <React.Fragment>
        <p style={{ margin: "5px 0" }}>
          <strong className={styles.bold}>{label}:</strong> {option.label}
        </p>
      </React.Fragment>
    );
  }

  renderInput() {
    return (
      <Async
        autoFocus={true}
        loadOptions={this.getOptions}
        loading={Boolean(!this.props.geojson)}
        onChange={this.handleOnChange}
        optionRenderer={this.optionsRenderer}
        filterOptions={(o) => o}
        isClearable={true}
        placeholder={"Search for a project, town or region"}
        noResultsText={
          "Sorry we didn't find anything; try exploring via the map instead."
        }
      />
    );
  }

  render() {
    if (!this.props.geojson) return null;
    return (
      <div className="Search">
        {this.renderInput()}
        <img
          className={styles.searchIcon}
          src={`${process.env.PUBLIC_URL}/img/search-icon.svg`}
          alt="search icon black"
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  projects: selectors.selectAllProjects(state),
  geojson: selectors.selectGeoJSON(state),
});

const mapDispatchToProps = {
  setActiveFeature,
  setActiveProject,
  setSearchedLocation,
  getGeoJSON,
  setSearchBarVisible,
  setSidebarIsOpen,
};

GeoSearchInput.propTypes = {
  setActiveFeature: PropTypes.func.isRequired,
  setActiveProject: PropTypes.func.isRequired,
  setSearchBarVisible: PropTypes.func.isRequired,
  setSidebarIsOpen: PropTypes.func.isRequired,
  projects: PropTypes.arrayOf(PropTypes.shape(projectShape)),
  geojson: PropTypes.object,
  geometryConfig: PropTypes.object.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(enhanceWithClickOutside(GeoSearchInput));



// WEBPACK FOOTER //
// ./src/components/search/search.js